export default "__VITE_ASSET__cd78b797__"